import * as lottieEmptyBox from './emptyBox.json';
import * as lottieLoading from './loading.json';
import * as lottieLoadingDark from './loading-dark.json';

export default {
  'empty-box': lottieEmptyBox.default,
  loading: lottieLoading.default,
  'loading-dark': lottieLoadingDark.default,
};
